import React from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { useSiteContext } from '../components/SiteContext';
import withApollo from '../lib/apollo';
import loading from '../lib/loading';
import getRedirectJob from '../lib/getRedirectJob';

const JobDetail = dynamic(() => import(
  '../components/Jobs/JobDetail'
), {
  ssr: true,
  loading,
});

export const JobPage = () => {
  const { query: { id } } = useRouter();
  const { jobsLocale } = useSiteContext();

  return (
    <JobDetail
      locale={jobsLocale}
      id={Number(id)}
    />
  );
};

JobPage.getInitialProps = getRedirectJob('job');

export default withApollo(JobPage);
